<div class="relative w-full border-2 border-l-8 border-gray-300 shadow-lg rounded-lg py-6 px-8 mb-10" *ngIf="document" [class]="document.documentType.isAnnex ? 'border-l-green-500' : 'border-l-laureate-500'">
    <!-- Content -->
    <div class="flex flex-col gap-y-4 w-full">
            
        <!-- Title -->
        <div class="flex items-center flex-col justify-center gap-y-4 md:flex-row md:justify-between">
            <div class="flex items-center justify-center gap-y-2 flex-col md:flex-row md:justify-start md:gap-x-4">
                <i class="fa-solid font-semibold text-2xl" [class]="icon"></i>
                <p class="text-regular font-light text-gray-500 text-wrap break-words">[{{ document.code }}]</p>
            </div>

            <!-- Options -->
            <div class="flex gap-x-2 md:mb-0 md:order-2">
                <button class="button circle sm" [class]="document.favorite ? 'red' : 'red-outline'" (click)="document.hasPrivileges && onClickFavoriteHandler()" title="Agregar/quitar de favoritos" [disabled]="!document.hasPrivileges">
                    <i class="fa-solid fa-heart icon"></i>
                </button>
                <button class="button circle sm sky" (click)="document.hasPrivileges && onClickViewHandler()" title="Visualizar" [disabled]="!document.hasPrivileges">
                    <i class="fa-solid fa-eye icon"></i>
                </button>
                <button class="button circle sm blue" *ngIf="document.download" (click)="document.hasPrivileges && onClickDownloadHandler()" title="Descargar" [disabled]="!document.hasPrivileges">
                    <i class="fa-solid fa-cloud-arrow-down icon"></i>
                </button>
                <button class="button circle sm green-light" *ngIf="document.hasAnnexes" (click)="document.hasPrivileges && onClickRelatedAnnexesHandler()" title="Consultar anexos" [disabled]="!document.hasPrivileges">
                    <i class="fa-solid fa-paperclip icon"></i>
                </button>
            </div>

        </div>

        <div class="break-words">
            <p class="font-semibold text-gray-900 text-center text-wrap md:text-left">
                {{ document.title }}
            </p>
        </div>

        <div class="break-words">
            <p class="text-sm text-gray-900 text-wrap break-words text-center md:text-justify">{{ document.subject }}</p>
        </div>

        <img *ngIf="document.brand.logo" [class]="logoSize" [src]="document.brand.logo" [alt]="document.brand.name" />

    </div>
</div>